import { Action } from 'redux';

import { IExtractTaskInfo } from '../../../ts/models/IExtractTaskInfo';
import { SetExtractRefreshPriority } from '../AppActionTypes';

export interface SetExtractRefreshPriorityAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function setExtractRefreshPriority(tasks: IExtractTaskInfo[]): SetExtractRefreshPriorityAction {
  return {
    type: SetExtractRefreshPriority,
    tasks
  };
}
